<template>
    <v-data-table
        :items="meterIndications"
        :headers="headers"
        :options.sync="meterIndicationsPagination"
        :server-items-length="meterIndicationsOptions.size"
        :loading="meterIndicationsOptions.loading"
        :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
        :class="meterIndicationsTableClass"
        ref="table"
    >
        <template #body.prepend>
            <table-arrows :table="$refs.table"></table-arrows>
        </template>
        <template v-slot:item.code_name_fact="{ item }">
            <table-cell-tooltip :header="headers[0]" :item="item">
                <div>{{ item.code_name_fact }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.date_consumption_begin="{ item }">
            <table-cell-tooltip :header="headers[1]" :item="item" filter="formatDate">
                <div>{{ item.date_consumption_begin | formatDate }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.date_consumption_end="{ item }">
            <table-cell-tooltip :header="headers[2]" :item="item" filter="formatDate">
                <div>{{ item.date_consumption_end | formatDate }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.heat_energy_all="{ item }">
            <table-cell-tooltip :header="headers[3]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.heat_energy_all | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.water_weight_on_gvs="{ item }">
            <table-cell-tooltip :header="headers[4]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.water_weight_on_gvs | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.work_time="{ item }">
            <table-cell-tooltip :header="headers[5]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.work_time | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.temperature_in="{ item }">
            <table-cell-tooltip :header="headers[6]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.temperature_in | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.temperature_out="{ item }">
            <table-cell-tooltip :header="headers[7]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.temperature_out | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.water_weight_out="{ item }">
            <table-cell-tooltip :header="headers[8]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.water_weight_out | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.temp_cold_water="{ item }">
            <table-cell-tooltip :header="headers[9]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.temp_cold_water | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.ServiceHeat="{ item }">
            <table-cell-tooltip :header="headers[3]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.ServiceHeat | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.ServiceHotWater="{ item }">
            <table-cell-tooltip :header="headers[4]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.ServiceHotWater | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.ServiceHOV="{ item }">
            <table-cell-tooltip :header="headers[5]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.ServiceHOV | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.ServiceRHOV="{ item }">
            <table-cell-tooltip :header="headers[6]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.ServiceRHOV | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.ServiceVent="{ item }">
            <table-cell-tooltip :header="headers[7]" :item="item" filter="formatDecimal">
                <div class="number-cell">{{ item.ServiceVent | formatDecimal }}</div>
            </table-cell-tooltip>
        </template>
        <template v-slot:item.user_name="{ item }">
            <table-cell-tooltip :header="findHeaderByValue('user_name')" :item="item">
                <div>{{ item.user_name }}&nbsp;,&nbsp;{{ item.edit_date | formatDateFull }}</div>
            </table-cell-tooltip>
        </template>
    </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import translate from '@/utils/translate.util';
import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';

export default {
    components: {
        TableCellTooltip,
        TableArrows
    },
    async mounted() {
        this.$watch(
            '$vuetify.breakpoint.xsOnly',
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.meterIndicationsOptions.pagination.itemsPerPage = 1;
                }
                if (oldVal) {
                    this.meterIndicationsOptions.pagination.itemsPerPage = 10;
                }
                this.meterIndicationsOptions.pagination.page = 1;
            },
            { immediate: true }
        );
    },
    computed: {
        ...mapState('meters', ['meterIndicationsFilter', 'meterIndicationsOptions']),
        meterIndicationsPagination: {
            get() {
                return this.meterIndicationsOptions.pagination;
            },
            set(value) {
                this.meterIndicationsOptions.pagination = value;
                this.getMeterIndicaitons(this.$parent.id);
            }
        },
        headers() {
            return [
                {
                    text: this.$t('Тип потребления'),
                    value: 'code_name_fact',
                    width: '1%'
                },
                {
                    text: this.$t('Дата начала'),
                    value: 'date_consumption_begin',
                    width: '1%'
                },
                {
                    text: this.$t('Дата окончания'),
                    value: 'date_consumption_end',
                    width: '2%'
                },
                ...(this.meterIndicationsFilter.tab == 1
                    ? [
                          {
                              text: this.$t('Теплоэнергия общая (гкал)'),
                              value: 'heat_energy_all',
                              width: '1%'
                          },
                          {
                              text: this.$t('Масса воды на ГВС (м3)'),
                              value: 'water_weight_on_gvs',
                              width: '2%'
                          },
                          {
                              text: this.$t('Рабочее время (ч)'),
                              value: 'work_time',
                              width: '1%'
                          },
                          {
                              text: this.$t('Температура ПВ (С)'),
                              value: 'temperature_in',
                              width: '1%'
                          },
                          {
                              text: this.$t('Температура ОВ (С)'),
                              value: 'temperature_out',
                              width: '1%'
                          },
                          {
                              text: this.$t('Масса воды в ОВ (м3)'),
                              value: 'water_weight_out',
                              width: '1%'
                          },
                          {
                              text: this.$t('Температура Хол.воды (С)'),
                              value: 'temp_cold_water',
                              width: '1%'
                          }
                      ]
                    : [
                          {
                              text: this.$t('Отопление (гкал)'),
                              value: 'ServiceHeat',
                              width: '2%'
                          },
                          {
                              text: this.$t('Горячая вода (гкал)'),
                              value: 'ServiceHotWater',
                              width: '1%'
                          },
                          {
                              text: this.$t('Химически очищенная вода (м3)'),
                              value: 'ServiceHOV',
                              width: '1%'
                          },
                          {
                              text: this.$t('Оказание услуги по реализации химически очищенной воды (м3)'),
                              value: 'ServiceRHOV',
                              width: '4%'
                          },
                          {
                              text: this.$t('Вентиляция (гкал)'),
                              value: 'ServiceVent',
                              width: '1%'
                          }
                      ]),
                {
                    text: this.$t('Данные вел'),
                    value: 'user_name',
                    width: '2%'
                }
            ];
        },
        meterIndicationsTableClass() {
            return `mt-7 meter-indications ${this.meterIndicationsFilter.tab === 1 ? 'meter-indications-one' : 'meter-indications-two'}`;
        },
        meterIndications() {
            return translate(this.$store.state.meters.meterIndications, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('meters', ['getMeterIndicaitons']),
        findHeaderByValue(value) {
            return this.headers.find(header => header.value === value);
        }
    }
};
</script>

<style lang="scss">
.meter-indications th {
    white-space: normal !important;
    text-align: start !important;
    vertical-align: top;

    span {
        display: block;
        font-size: 14px;
        padding: 10px 0px;
    }
}
</style>
